<!--
 * @Author: dee
 * @Date: 2022-04-19 17:22:25
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-04-21 17:13:21
 * @Description: file content
-->
<template>
  <div class="bg">
    <BaseImg :option="{
      style: {
        margin: '12px 0 0 16px',
        alignSelf: 'flex-start',
        width: '89px',
      },
      url: 'logo.png',
    }"/>
    <div class="coupon-box">
      <div class="coupon-list">
        <div class="coupon-item"
          v-for="(v, i) in thisCouponList"
          :key="'coupon' + i"
          :style="{background: 'url(' + imgHost + 'coupon' + v.picId + '.png?v=' + $OSSVersion + ') 0 0 / 100% no-repeat'}"
        >
          <div class="group-btn" @click="goTeam(v)">去开团</div>
          <div class="detail" @click="toDetail(v)">查看详情</div>
        </div>
      </div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      couponList: [
        {
          picId: 1,
          name: '文创甬江城',
          detail: `1. 此券仅限本人使用，不得转让；
                  <br />2. 优惠券有效期至2022年4月30日；
                  <br />3. 仅限于文创甬江城21/22/25幢住宅110户型；
                  <br />4. 地址：宁波市江北区大庆北路中兴大桥西侧（文创甬江城营销中心）`,
        },
        {
          picId: 2,
          name: '宝龙TOD奉甬新城-东腾璟庭',
          detail: `1、此券仅限本人使用，不得转让
                  <br />2、优惠券有效期至2022年5月31日
                  <br />3、使用地址：浙江省宁波市奉化区华元欢乐城宝龙大成路营销中心
                  <br />4、仅限宝龙大成路项目（东腾璟庭）住宅产品使用。`,
        },
        {
          picId: 3,
          name: '宝龙TOD奉甬新城-澜沁璟庭',
          detail: `1、此券仅限本人使用，不得转让
                  <br />2、优惠券有效期至2022年5月31日
                  <br />3、使用地址：浙江省宁波市奉化区金海路宝龙TOD奉甬新城营销中心
                  <br />4、仅限宝龙TOD奉甬新城9期澜沁璟庭住宅产品使用，其他产品不参与。`,
        },
        {
          picId: 4,
          name: '新生圩宝龙广场',
          detail: `内容：在售住宅总价优惠10000元
                  <br />有效期：即日起至2022年5月20日
                  <br />使用方式：凭参与活动页面截图至项目，购房即可减免
                  <br />使用地址：江苏省南京市栖霞区恒发路与仙新路交汇处新生圩宝龙广场营销中心`,
        },
        {
          picId: 5,
          name: '宝龙·TOD未来新城',
          detail: `使用时间：通过原圈线上活动，购买住宅产品成交总价基础上优惠2万元，
                  <br />认购时间截止为2022年5月31日；认筹公寓产品可享受缴1万抵3万总价优惠，认筹优惠截止时间为公寓产品开盘前
                  <br />使用方式：仅限参与活动客户本人及其直系亲属购房使用，不得二次转让；
                  <br />使用地址：无锡宝龙TOD未来新城项目+无锡宝龙世家项目`,
        },
        {
          picId: 6,
          name: '宜兴宝龙广场',
          detail: `有效期：2022年5月31日前使用
                  <br />宜兴市丁蜀镇陶都路与东坡西路交汇处`,
        },
        {
          picId: 7,
          name: '奉发宝龙广场',
          detail: `美好生活卡3000抵10000、
                  <br />2022年6月30日、
                  <br />开盘后认购总价抵扣`,
        },
        {
          picId: 8,
          name: '温岭云樾珑湾',
          detail: `1、此券仅限本人使用，不得转让
                  <br />2、优惠券有限期至2022年4月30日
                  <br />3、次券仅限云樾珑湾3号楼使用
                  <br />4、使用地址：温岭宝龙广场（云樾珑湾展厅）`,
        },
        {
          picId: 9,
          name: '常州宝龙广场',
          detail: `1、1元抢1%购房优惠券，此优惠券仅限于购房宝龙广场三期公寓产品，商铺、车位不参与；
                  <br />2、此优惠券仅限本人使用，不得转让；
                  <br />3、此优惠券有限期至2022年5月31日`,
        },
        {
          picId: 10,
          name: '宝龙·TOD未来新城',
          detail: `使用时间：通过原圈线上活动，购买住宅产品成交总价基础上优惠2万元，
                  <br />认购时间截止为2022年5月31日；认筹公寓产品可享受缴1万抵3万总价优惠，认筹优惠截止时间为公寓产品开盘前
                  <br />使用方式：仅限参与活动客户本人及其直系亲属购房使用，不得二次转让；
                  <br />使用地址：无锡宝龙TOD未来新城项目+无锡宝龙世家项目`,
        },
      ],
      thisCouponList: []
    };
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
    this.groupInfo();
  },
  methods: {
    goTeam(v) {
      if (v.inStock) {
        this.$goPage(`team?prizeId=${v.id}`);
      } else {
        this.$showModal("该券已经被抢完！");
      }
    },
    toDetail(v) {
      this.$modal.drawForm.alert({
        couponDetail: true,
        drawTxt: 6,
        btnTxt: '我知道了',
        thanksTxt: v.detail,
      })
    },
    async groupInfo() {
      const data = await this.$httpdf.get(this.apiHost + 'groupBuy/info')
      if(data.code == 0){
        data.data.goods.map(val => {
          this.couponList.map(v => {
            if(val.prizeIcon == v.picId) {
              val.detail = v.detail
              val.picId = v.picId
            }
          })
        });
        this.thisCouponList = data.data.goods
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.bg {
  padding-bottom: 60px;
  background: url( $imgHost + 'index_top.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, linear-gradient(0deg, #FAE5C7 0%, #F6C574 100%);
  .coupon-box {
    margin: 247px auto 0;
    position: relative;
    z-index: 2;
    padding: 0 15px;
    .coupon-list {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      .coupon-item {
        width: 346px;
        height: 96px;
        padding: 33px 0 0 16px;
        // display: flex;
        // flex-flow: column wrap;
        // justify-content: center;
        &+.coupon-item {
          margin-top: 12px;
        }
        .group-btn {
          width: 60px;
          height: 21px;
          border: 1px solid rgba($color: #FFFFFF, $alpha: 0.8);
          border-radius: 10px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          @extend .flex-center-center;
        }
        .detail {
          margin-top: 8px;
          width: 60px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #E97332;
          text-align: center;
        }
      }
    }
  }
}
</style>
